export default {
      id: "icon--calendar-nav-usage",
      viewBox: "0 0 22.8 22.8",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--calendar-nav-usage",
      toString: function () {
        return this.url;
      }
    }